<template>
    <div>
        <div class="d-flex flex-column align-items-center text-center bg-white pt-5 pb-4 pb-lg-4 px-3 mb-0 mb-lg-0">
           <div class="d-flex flex-column px-lg-5 px-3 mb-4 align-items-center text-center">
                <img alt="" src="/img/hcpay/hc-icon.svg" class="img-responsive mb-4" style="height:auto;width:2.5rem">
                <span class="font-md font-weight-bold mb-1">{{EnumLabels.BUY_NOW}}</span>
                <span class="font-s text-secondary">{{EnumLabels.OUR_HOME}}</span>
            </div>
            <div class="col-lg-8 col-xs-12 mb-4 chat-card">
                <div class="col-12 text-left px-2 py-4 w-100 border-bottom">
                    <img alt="" src="/img/hcpay/merchant.svg" class="warningIcon img-responsive mr-2">
                    <span class="align-middle font-weight-bold">{{ this.$root.$data.transaction.merchantName }}</span>
                </div>
                <div class="col-12 text-left px-2 py-3 w-100 border-bottom d-flex justify-content-between">
                    <span class="font-sm text-secondary text-gray-dk">Total Amount</span>
                    <span class="font-sm text-secondary text-gray-dk">₱ {{ toCurrency(this.$root.$data.transaction.amount) }}</span>
                </div>
                <div class="col-12 text-left px-2 py-3 w-100 d-flex justify-content-between">
                    <span class="font-sm text-secondary text-gray-dk">Reference No.</span>
                    <span class="font-sm text-secondary text-gray-dk">{{ this.$root.$data.transaction.referenceNumber }}</span>
                </div>
                <div class="col-12 px-2 d-flex justify-content-center">
                    <info-bar class="mt-4 mb-2 col-sm-12 col-md-12 col-lg-12 text-left" bgColor="#e9f4fe">
                        Chat with a Home Credit agent on
                        <br />
                        Messenger to shop in easy installments.
                    </info-bar>
                </div>
                <div class="col-12 mt-2 mb-3 px-2 d-flex justify-content-center">
                    <a
                        target="_self"
                        rel="noopener"
                        class="btn btn-primary col-sm-12 
                        col-md-12 col-lg-12 d-flex align-items-center
                        px-4 py-2 messager-button"
                        @click="messagerLink"
                    >
                        <svg width="24" height="25" class="mr-2" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.01 0.697266C5.25003 0.697266 0.00976562 5.64891 0.00976562 12.3372C0.00976562 15.8359 1.44356 18.8584 3.77833 20.9469C3.97465 21.1221 4.09273 21.3683 4.10089 21.6309L4.16617 23.7659C4.18681 24.4465 4.89051 24.8896 5.51308 24.6145L7.89487 23.5629C8.09697 23.4741 8.32307 23.4573 8.53567 23.5163C9.63057 23.8173 10.7951 23.9776 12.0096 23.9776C18.7695 23.9776 24.0098 19.0259 24.0098 12.3377C24.0098 5.64939 18.77 0.697266 12.01 0.697266ZM19.4464 9.23107L15.2683 15.6881C15.0562 16.0159 14.6189 16.1095 14.291 15.8973L10.4207 13.3932C10.271 13.2962 10.077 13.2991 9.93017 13.4004L5.5678 16.409C4.93131 16.8477 4.15321 16.0927 4.57322 15.4437L8.75167 8.98677C8.96387 8.65897 9.40117 8.56537 9.72857 8.77757L13.5998 11.2822C13.7496 11.3791 13.9435 11.3763 14.0904 11.275L18.4518 8.26677C19.0883 7.82757 19.8664 8.58217 19.4464 9.23107Z" fill="white"/>
                        </svg>
                        <span>Buy now with Home Credit</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column rounded align-items-center px-0 py-4 bg-white my-2">
            <download-opg-v3 class="px-4" google-play-id="loginGooglePlayBtn" qr-code-id="loginQRCode"></download-opg-v3>
        </div>
    </div>
</template>
<script>
import { EnumLabels } from '../../enums/CommonString.js';
export default {
    data() {
        return {
            EnumLabels,
            error: this.$root.error,
            downloadEventName: 'err_no_hc_acct_install_hc_app',
        }
    },
    created(){
        if(this.$root.transaction.page == "lazada") {
            this.transcation_type = "WT";
        } else {
            this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
        }
        let g4params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.transcation_type,
            'transaction_reference': this.$root.$data.transaction.referenceNumber,
        }       
        this.$root.triggerG4Event('social_commerce_chat',g4params);
        this.$root.$data.previousView = 'not-available';
    },
    methods: {
        openSite(){
            window.location.href = "https://homecredit.ph/credit-card/";
        },
        websiteDirect() {
            if(this.$root.transaction.page == "lazada") {
                this.transcation_type = "WT";
            } else {
                this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
            }
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.transcation_type,
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_visit_website',g4params)
        },
        backButton() {
            if(this.$root.transaction.page == "lazada") {
                this.transcation_type = "WT";
            } else {
                this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
            }
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.transcation_type,
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_back_to_store',g4params)
        },
        shoppingMall() {
            if(this.$root.transaction.page == "lazada") {
                this.transcation_type = "WT";
            } else {
                this.transcation_type = this.$root.$data.transaction.referenceNumber.substring(0, 2);
            }
            let g4params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.transcation_type,
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
            }       
            this.$root.triggerG4Event('err_no_hc_acct_click_check_available_offers',g4params);
            const merchant = this.$root.$data.transaction.merchantName;
            let redirectUrl = "https://shop.shoppingmall.ph/download-home-credit-app-now";
            if (merchant) {
                redirectUrl = `${redirectUrl}?utm_source=dp_partner_${merchant}`;
            } else if (this.$root.transaction.page === "lazada") {
                redirectUrl = `${redirectUrl}?utm_source=dp_partner_Lazada`;
            }
            const encodedRedirect = encodeURI(redirectUrl);
            window.location.href = encodedRedirect;
        },
        messagerLink() {
            // Optimized: Build Messenger link with product and merchant name
            const { products = [], merchantName = '' } = this.$root.$data.transaction;
            const itemNames = products.map(p => p?.name).filter(Boolean).join(', ');
            const text = `Hi there! I'd like to purchase ${itemNames} from ${merchantName} with a Home Credit installment plan. Can you help me with this?`;
            const goLink = `http://m.me/homecreditph?text=${encodeURIComponent(text)}`;
            window.open(goLink, '_self');
            return goLink;
        },
        toCurrency(value) {

            // Check if the value is NaN or empty (null, undefined, or other falsy values)
            if (!value || isNaN(value)) {
                value = 0;
            }

            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
    }
}
</script>
<style scoped>
    .chat-card {
        border-radius: 1rem;
        box-shadow: 0 4px 16px 0 rgba(0,0,0,0.10);
        background: #fff;
    }
    .errorMessageIcon {
        height: auto;
        width: 9rem;
    }
    .paymentOptionCard {
        height: auto;
        width: 8rem;
    }
    .text-tertiary {
        color: #8C8C8C !important;
        margin-top: 1em;
    }
    .creditcardBg {
        background-color: #2196F3;
    }
    .walletpayBg {
        background-color: #009688;
    }
    .link-hc-site:hover{
        color: #49B672;
    }
    .messager-button { 
        background-color: #0084ff; 
        border: none; 
        border-radius: 20px; 
        font-weight: 600; 
        font-size: 1rem; 
        color: #fff;
        box-shadow: 0 2px 8px #0001; 
        gap: 0.5rem;
    }
    .messager-button:hover { 
        color: #fff;
    }
</style>